import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useLocation,useParams, Outlet, useNavigate } from 'react-router-dom';
import { PiCaretDoubleLeft,PiCaretLeft,PiCaretDoubleRight,PiCaretRight, PiBankLight,PiMoneyLight, PiMoneyWavyLight} from "react-icons/pi";

import client from '../client';
import {ContentContainer, ListItem} from 'coaz-ui';


const Accounts = () => {
    const [accounts,setAccounts] = useState([]);
    const {currentUserId,accountId} = useParams();
    const [pageNo,setPageNo] = useState(0);
    const [pageSize,setPageSize] = useState(0);
    const [totalElements,setTotalElements] = useState(0);
    const [totalPages,setTotalPages] = useState(0);
    const [last,setLast] = useState(true);
    const [page,setPage] = useState({
        pageNo:0,
        pageSize:10
    })
    const [loading,setLoading] = useState(false);
    const {request,getCurrent,errorMessage} = client;
    const path = useLocation().pathname;

    const navigate = useNavigate();

    const handleFirst = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo > 0) {
            setPage({...page, pageNo: 0});
        }
    }

    const handlePrevious = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo > 0) {
            setPage({...page, pageNo: page.pageNo - 1});
        }
    }

    const handleNext = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo < totalPages - 1) {
            setPage({...page, pageNo: page.pageNo + 1});
        }
    }

    const handleLast = (e) => {
        if(e) e.preventDefault();
        if(page.pageNo < totalPages - 1 && !last) {
            setPage({...page, pageNo: totalPages - 1});
        }
    }

    const getAccounts = async (page) => {
        let current = await getCurrent();
        
        if (!current && !current.user) {
            setLoading(false);
            setAccounts([]);
            return;
        }

        let readAuth = current.authorities.find((auth) => {return auth.authority === 'ACCOUNT:READ'});
        
        if(!readAuth) {
            setLoading(false);
            setAccounts([]);
            return;
        }

        await request('GET','accounts/page',null,{
            pageNo:page.pageNo,
            pageSize:page.pageSize})
        .then((response) => {
            if(response.content) {
                setAccounts(response.content);
                setPageNo(response.pageNo);
                setPageSize(response.pageSize);
                setTotalElements(response.totalElements);
                setTotalPages(response.totalPages);
                setLast(response.last);
            } else {
                setAccounts([]);
            }
        })
        .catch((error) => {
            setAccounts([]);
        });
        
        setLoading(false);
    }

    const onOpen = (item) => {
        if(!item || !item.id) return;
        navigate(`${path}/_account/${item.id}`)
    }

    useEffect(() => {
        getAccounts(page);
    },[path,page])
  return (
    <>{accountId?
        <Outlet/>:
        <ContentContainer
            Icon={PiBankLight} 
            text='Accounts' 
            scrollable={true}
            background={true}
            loading={loading}>
            {accounts  && totalElements >  pageSize &&
                <div className='flex flex-wrap items-center justify-between w-full p-4 h-fit'>
                    <p className='text-xs font-helveticaNeueRegular text-[rgb(145,145,145)] tracking-wider'>
                        {`Showing ${accounts && accounts.length > 0?(pageNo * pageSize)+1:0} to ${((pageNo * pageSize)+accounts.length)} of ${totalElements}`}
                    </p>
                    <div className='flex flex-row w-fit h-fit space-x-2 text-[rgb(68,71,70)]'> 
                        <button 
                            disabled={!pageNo || pageNo < 1}
                            onClick={handleFirst}
                            className={`flex w-10 h-10 ${pageNo < 1?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                        >
                            <PiCaretDoubleLeft size={16} className='flex m-auto'/>
                        </button>
                        <button 
                            disabled={!pageNo || pageNo < 1}
                            onClick={handlePrevious}
                            className={`flex w-10 h-10 ${pageNo < 1?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                        >
                            <PiCaretLeft size={16} className='flex m-auto'/>
                        </button>
                        <button 
                            disabled={last}
                            onClick={handleNext}
                            className={`flex w-10 h-10 ${last?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                        >
                            <PiCaretRight size={16} className='flex m-auto'/>
                        </button>
                        <button 
                            disabled={last}
                            onClick={handleLast}
                            className={`flex w-10 h-10 ${last?'text-[rgb(170,170,170)]':'hover:bg-[rgba(0,0,0,.04)]'} rounded-full`}
                        >
                            <PiCaretDoubleRight size={16} className='flex m-auto'/>
                        </button>
                    </div>
                </div>
            }
            {accounts && accounts.length > 0 &&
            <div className='flex flex-col w-full h-auto p-4 space-y-2'>
                {accounts.map((account,i) => 
                <ListItem key={i} 
                    Icon={PiBankLight} 
                    item={{id:account.ref.id,text:account.name}} 
                    handleOpen={onOpen}
                />)}
            </div>
            }
        </ContentContainer>
    }
    </>
  )
}

export default Accounts

const AccountItem = ({account}) => {
    const [balance,setBalance] = useState(0);
    const {currentUserId} = useParams(); 
    const path = useLocation().pathname;
    const {request,errorMessage} = client;

    let USDecimal = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    const navigate = useNavigate();

    useEffect(() => {
        if(account) {
            request('GET',`account/balance/${account.id}`,null,null,true)
            .then((response) => {
                if(response.content) {
                    setBalance(response.content);
                } else {
                    setBalance(0);
                }
            })
            .catch((error) => {
                setBalance(0)
            })
        }
    },[])

    return (
        <div className='flex flex-row w-full h-auto'>
            {account &&
            <div className='flex flex-row w-full p-2 items-center justify-between space-x-4 hover:bg-[rgba(0,0,0,.04)] rounded-md'>
                <div onClick={(e) => navigate(`${path}/_account/${account.id}`)}
                    className='flex flex-row items-center space-x-2 cursor-pointer w-fit shrink-0'>
                    <PiMoneyWavyLight size={40} className='text-[rgb(0,175,240)] shrink-0'/>
                    <div className='flex flex-col w-full h-fit'>
                        <p className={`text-sm text-[rgb(68,71,70)] font-helveticaNeueRegular whitespace-nowrap overflow-hidden overflow-ellipsis capitalize`}>
                            {`${account.holder && account.holder.name?account.holder.name:account.name}`}
                        </p>
                        <p className='text-xs text-[rgb(145,145,145)] font-helveticaNeueRegular capitalize whitespace-nowrap overflow-hidden overflow-ellipsis'>
                            {`Balance : K ${USDecimal.format(balance)}`}
                        </p>
                    </div>
                </div>
            </div>}
        </div>
    )
}